import { WebchatEventListenerCallback } from "../../definitions";
import { ACTION_ADD_WEBCHAT_EVENT_LISTENER } from "../actionTypes";

export const addWebchatListener = (event: string, listenerCb: WebchatEventListenerCallback) => {
    return {
        type: ACTION_ADD_WEBCHAT_EVENT_LISTENER,
        payload: {
            event,
            listenerCb
        }
    };
};
